import styled from 'styled-components';
import { FilterBoxWrapper } from '../../components/common';
import { FilterCriteriaWrapper } from '../../components/common';

export const FilterWrapper = styled(FilterBoxWrapper)`
  height: 100%;

  /* The drawer body scrolls; an inner scroller here would clip in-flow menus. */
  ${FilterCriteriaWrapper} {
    max-height: none;
    overflow: visible;
  }
`;
